const Vue = require('vue')
const $ = require('jquery')
const moment = require('moment')
const pCustomer = require('../ui/property-customer')
const htmlTemplate = require('templates/properties/info.html')
const SCI = require('sci');
const request = require('sci/helpers/request')
const {client, defaultPagination} = require('sci/helpers')

const {url} = require('sci/utils')

const vueChaos = require('sci/helpers/vue-chaos')

const CustomerMailPropertiesModal = require('components/customer/MailPropertiesModal.vue')

const FormWidget = require('components/form/Widget.vue')
const availabilities = require('pages/old-properties/_editor/availabilities.js')

const DateHolder = {
    props: {
        property: {
            default: () => {
            },
            Type: Object
        }
    },
    created() {
        availabilities.boot(this)
    },
    data() {
        return {
            ui: {
                loadingCalendar: true,
            }
        }
    },
    template: `
        <div>
        <div id='#property-availability-editor' style="width: 40%;float: left;">
            <div class="legenda-calendar">
                <div class="legend-item">
                    <span class="legend-box box-white"></span>
                    <span>Disponível</span>
                </div>
                <div class="legend-item">
                    <span class="legend-box box-indisp"></span>
                    <span>Indisponível</span>
                </div>
            </div>
        </div>
        </div>
    `
}

const defaultOptions = {
    editApproval: false,
    onApprovalChange: () => {
    },
    current: (i) => i.ui.currentKey + 1,
    limit: (i) => i.circling.length,
    hasNext: (i) => i.circling[i.ui.currentKey + 1] !== undefined,
    hasPrevious: (i) => i.ui.currentKey > 0 && i.circling.length > 1,
    toNext: (i) => {
        return new Promise((result) => {
            if (!i.hasNext) {
                result(false)
                return
            }

            result(i.circling[i.ui.currentKey + 1])
        })
    },
    toPrevious: (i) => {
        return new Promise((result) => {
            if (!i.hasPrevious) {
                result(false)
                return
            }

            result(i.circling[i.ui.currentKey - 1])
        })
    }
}

const buildVm = (data, propertyId, tab = null, circling = [], options = {}) => {
    console.log(tab)
    const instance = SCI.get('instance');

    const Component = Vue.extend({
        components: {
            DuplicatePropertyModal: require('components/property/DuplicateModal.vue'),
            CustomerMailPropertiesModal,
            FormWidget,
            DateHolder,
            PhotoView: require('components/photo/CompactView.vue'),
            PropertyTitle: require('components/property/Title.vue'),
            UiConfirm: require('components/ui/Confirm.vue')
        },
        template: htmlTemplate,
        data() {
            return {
                options: {...defaultOptions, ...options},
                propertyId,
                tab,
                circling,
                info: data,
                interestedForms: [],
                selectedInForms: [],
                displayAll: false,
                settings: {
                    properties: {
                        approval: instance.overrides["sci.settings.properties.approval"]
                    }
                },
                ui: {
                    show: {
                        address: false,
                        referencePoint: false,
                        notes: false,
                        keys: false,
                        internalNotes: false,
                        registry: false,
                        deed: false,
                        registrationNumber: false,
                        waterNumber: false,
                        energyNumber: false,
                        iptuNumber: false,
                        owner: false,
                        recommended: false,
                        selectedInForms: false,
                        approval_comment: true
                    },
                    loading: false,
                    ignoreHide: false,
                    loadingInterestedForms: false,
                    loadingSelectedInForms: false,
                    interestedFormsPagination: defaultPagination(),
                    selectedInFormsPagination: defaultPagination(),
                    next: null,
                    currentKey: 0
                }
            }
        },
        ready() {
            $(this.$els.modal).modal()

            if (!this.info) {
                this.load()
            } else {
                // $tpl.find('.carousel').carousel();
            }

            if (this.tab) {
                this.$nextTick(() => this.showTab())
            }
            $(this.$els.modal).on('hidden.bs.modal', () => {
                if (this.ui.ignoreHide) {
                    this.ui.ignoreHide = false
                    return
                }
                this.$remove()
            })
        },
        methods: {
            clone() {
                this.$refs.duplicatePropertyModal.show(this.propertyId)
            },
            showGallery(base, index, start = 'photos') {
                this.$refs.gallery.show(base, index, start)
            },
            toggleCustomers() {
                this.ui.show.owner = !this.ui.show.owner
            },
            showCustomer(data) {
                pCustomer.fastCustomer(data)
            },
            featuresList(features) {
                return features.map(i => i.name).join(' - ')
            },
            showAll() {
                this.displayAll = !this.displayAll
                this._showAll()
            },
            _showAll() {
                for (const i in this.ui.show) {
                    this.ui.show[i] = this.displayAll
                }
            },
            toPrevious() {
                this.ui.loading = true
                this.options.toPrevious(this).then((i) => {
                    if (i) {
                        this.propertyId = i
                        this.load()
                    } else {
                        this.ui.loading = false
                    }
                })
            },
            toNext() {
                this.ui.loading = true
                return this.options.toNext(this).then(i => {
                    if (i) {
                        this.propertyId = i
                        this.load()
                    } else {
                        this.ui.loading = false
                    }
                })
            },
            load() {
                // $tpl.find('.carousel').carousel('destroy');
                this.ui.loading = true
                client
                    .silent()
                    .get('Carregando imóvel...', `properties/${this.propertyId}`)
                    .then(vueChaos(this.$els.holder))
                    .then((data) => {
                        this.ui.loading = false
                        this.info = data
                        this._showAll()
                        if (Array.isArray(this.circling)) {
                            this.circling.map((item, key) => {
                                if (item === this.propertyId) {
                                    this.ui.currentKey = key
                                }
                            })
                        }

                        this.$nextTick(() => this.showTab())
                    })
            },

            loadInterestedForms(page) {
                this.ui.loadingInterestedForms = true

                client
                    .silent()
                    .get('Carregando...', `properties/${this.propertyId}/interested-forms`, {
                        page
                    })
                    .then((data) => {
                        this.interestedForms = data.data
                        this.ui.interestedFormsPagination = data.meta.pagination

                        this.ui.loadingInterestedForms = false
                    })
            },
            loadSelectedInForms(page) {
                this.ui.loadingSelectedInForms = true

                client
                    .silent()
                    .get('Carregando...', `properties/${this.propertyId}/selected-in-forms`, {
                        page
                    })
                    .then((data) => {
                        this.selectedInForms = data.data
                        this.ui.selectedInFormsPagination = data.meta.pagination

                        this.ui.loadingSelectedInForms = false
                    })
            },
            showTab() {
                if (this.tab) {
                    $(`a[href='#property-info-${this.tab}']`, this.$els.modal).tab('show')
                    if (this.tab === 'forms') {
                        this.ui.showForms = true
                        this.loadInterestedForms()
                    }
                }
            },
            showAddress() {
                this.ui.showAddress = !this.ui.showAddress
            },
            showReferencePoint() {
                this.ui.showReferencePoint = !this.ui.showReferencePoint
            },
            showOwner() {
                this.ui.showOwner = !this.ui.showOwner
            },
            showEmailModal() {
                this.ui.ignoreHide = true

                $(this.$els.modal).modal('hide')

                this.$refs.customerMailPropertiesModal.$once('closed', () => {
                    $(this.$els.modal).modal('show')
                })

                this.$refs.customerMailPropertiesModal.show([this.info.id])
            },
            hideModal() {
                $(this.$els.modal).on('hidden.bs.modal', () => {
                    this.$remove()
                })

                $(this.$els.modal).modal('hide')
            },
            showRecommended() {
                this.ui.show.recommended = !this.ui.show.recommended

                if (this.ui.show.recommended) {
                    this.loadInterestedForms(1)
                }
            },
            showSelectedInForms() {
                this.ui.show.selectedInForms = !this.ui.show.selectedInForms

                if (this.ui.show.selectedInForms) {
                    this.loadSelectedInForms(1)
                }
            },
            confirmApproval() {
                this.$refs.approveConfirm.show();
            },

            rejectApproval() {
                this.$refs.reproveConfirm.show();
            },
            doApproveApproval() {
                return this.updatePropertyApprovalState(1, this.$refs.approveConfirm)
            },

            doRejectApproval(confirmForm) {
                console.log(confirmForm, confirmForm.comment);
                return this.updatePropertyApprovalState(3, this.$refs.reproveConfirm, confirmForm.comment)
            },

            updatePropertyApprovalState(newApprovalState, $ref, reason = "") {
                client
                    .post('Carregando...', `properties/${this.info.id}/approval`, {
                        'approval_status': newApprovalState,
                        approval_comment: reason
                    })
                    .then(vueChaos($ref))
                    .then((data) => {
                        this.info.approval_status = newApprovalState;

                        if (typeof this.options.onApprovalChange === 'function') {
                            this.options.onApprovalChange();
                        }

                        this.hideModal();
                    })
            }

        },
        computed: {
            calculatedAge() {
                if (this.info.construction_year) {
                    const age = new Date().getFullYear() - this.info.construction_year;

                    if (age > 1) {
                        return ` (${age} anos)`
                    }

                    return ` (${age} ano)`
                }

                return ''
            },
            mapIframePath() {
                return `${url('/utils/google-maps')}?latitude=${this.info.latitude}&longitude=${this.info.longitude}&title=imóvel`;
            },

            websiteUrl() {
                if (this.info.websites && this.info.websites.length > 0) {
                    return this.info.websites[0].property_url
                }

                return null
            },

            websiteLandingPageUrl() {
                if (this.info.websites && this.info.websites.length > 0) {
                    return this.info.websites[0].property_landing_page_url
                }

                return null
            },

            websiteLandingPageWithoutPricesUrl() {
                if (this.info.websites && this.info.websites.length > 0) {
                    return this.info.websites[0].property_landing_page_without_prices_url
                }

                return null
            },


            currentItem() {
                return this.options.current(this)
            },

            limit() {
                return this.options.limit(this)
            },
            changeImage(id) {
                $(this.$els.photoCarousel).carousel(id)
            },
            hasBuilding() {
                return this.info.building !== null
            },
            hasFeatures() {
                return this.info.proximities.length > 0 ||
                    this.info.features.length > 0 ||
                    this.info.rooms.filter(i => i.features.length > 0).length > 0
            },
            totalItems() {
                if (Array.isArray(this.circling)) {
                    return this.circling.length
                }

                return this.circling.totalItems()
            },
            hasPrevious() {
                return this.options.hasPrevious(this)
            },
            hasNext() {
                return this.options.hasNext(this)
            },
            paymentMethods: function () {
                const str = []

                if (this.info.fgts) {
                    str.push('FGTS')
                }

                if (this.info.capitalization_bond) {
                    str.push('Titulo de Capitalização')
                }

                if (this.info.letter_of_credit) {
                    str.push('Carta de Crédito')
                }

                if (this.info.bank_financing) {
                    str.push('Financiamento Bancário')
                }

                if (this.info.direct_financing) {
                    str.push('Financiamento Direto')
                }

                if (this.info.mcmv) {
                    str.push('Minha Casa Minha Vida')
                }

                if (this.info.exchange) {
                    str.push('Permuta')
                }

                return str.join(' - ')
            },
            rentalRequirements: function () {
                const str = []

                if (this.info.lessor_bail) {
                    str.push('Seguro fiança')
                }
                if (this.info.guarantor) {
                    str.push('Fiador')
                }
                if (this.info.deposit) {
                    str.push('Depósito')
                }
                if (this.info.requires_guarantor_deed) {
                    str.push('Escritura do fiador')
                }

                return str.join(' - ')
            }
        }
    })

    const vm = new Component()

    vm.$mount()
        .$appendTo('#trash-holder', null, false)
}

Vue.directive('property-info', {
    params: ['id', 'data', 'tab', 'circling', 'options'],
    paramWatchers: {
        id() {
            $(this.el).unbind().click(() => {
                buildVm(this.params.data, this.params.id, this.params.tab, this.params.circling, this.params.options)
            })
        },
        data() {
            $(this.el).unbind().click(() => {
                buildVm(this.params.data, this.params.id, this.params.tab, this.params.circling, this.params.options)
            })
        }
    },
    bind: function () {
        $(this.el).unbind().click(() => {
            buildVm(this.params.data, this.params.id, this.params.tab, this.params.circling, this.params.options)
        })
    },
    update() {
        $(this.el).unbind().click(() => {
            buildVm(this.params.data, this.params.id, this.params.tab, this.params.circling, this.params.options)
        })
    }
})

Vue.component('property-info-handler', {
    data: () => ({
        propertyId: null,
        propertyData: null,
        circling: null,
        options: null,
        propertyTab: null
    }),
    methods: {
        showById(propertyId, circling = [], options = {}, tab) {
            this.propertyId = propertyId
            this.propertyData = null
            this.circling = circling
            this.options = options
            this.propertyTab = tab
            Vue.nextTick(() => $(this.$els.fakeLink).click())
        },
        showByData(data) {
            this.propertyId = null
            this.propertyData = data

            Vue.nextTick(() => $(this.$els.fakeLink).click())
        }
    },
    template: `
        <div>
        <a href="javascript:;" v-el:fake-link v-property-info :tab="propertyTab" :data="propertyData" :circling="circling"
           :options='options' :id="propertyId"></a>
        </div>
    `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/property-info.js